import tw from "twin.macro";
import React from "react";
import { type UseFormRegisterReturn } from "react-hook-form";
import { FieldError } from "~/features/ui/form/field-error";

type Props = {
  label?: string;
  error?: string;
  register?: UseFormRegisterReturn;
  children?: React.ReactNode;
};

const style = tw`
  h-64 w-full text-mobile-body-30-normal lg:(text-desktop-body-30-normal) appearance-none bg-white-100-light
  px-16 border-b border-b-grey-40-light rounded-2 text-black-80-light
  disabled:(pointer-events-none bg-black-transparent-20-dark text-grey-50-dark)
`;

export const Input = React.forwardRef<HTMLInputElement, Props & React.ComponentPropsWithRef<"input">>((props, ref) => {
  const { label, error, register, children, ...rest } = props;

  return (
    <label htmlFor={rest.name} css={[tw`flex flex-col w-full`, rest.disabled && tw`pointer-events-none`]}>
      {label && (
        <span tw="font-aeonik text-mobile-caption-30-normal lg:text-desktop-caption-30-normal text-grey-100-light mb-16 block">
          {label}
          {rest.required && <span tw="text-blue-100 ml-8">*</span>}
        </span>
      )}
      <div tw="relative w-full">
        <input
          ref={ref}
          aria-invalid={Boolean(Error) ? "true" : "false"}
          css={[style, Boolean(error) && tw`text-error placeholder-error border-error`]}
          {...register}
          {...rest}
        />
        {children}
        {error && <FieldError message={error} />}
      </div>
    </label>
  );
});
